var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgDashboard = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 11,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.5 0A2.5 2.5 0 0 1 12 2.5v6a2.5 2.5 0 1 1-5 0v-6A2.5 2.5 0 0 1 9.5 0Zm-7 6a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Zm0-6a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Z"
})));

export default SvgDashboard;